export const getPathOnly = (url?: string | null): string => {
    const s = String(url || '');

    const noHash = s.split('#')[0];
    const noQuery = noHash.split('?')[0];

    const m = noQuery.match(/^https?:\/\/[^/]+(\/.*)?$/i);
    if (m) return m[1] || '/';

    if (noQuery.startsWith('/')) return noQuery;

    return `/${noQuery}`;
};